import { passkeyClient } from "@better-auth/passkey/client";
import { createAuthClient } from "better-auth/react";
import { emailOTPClient } from "better-auth/client/plugins";

const authClient = createAuthClient({
  baseURL: window.location.origin,
  basePath: "/v1/auth",
  plugins: [emailOTPClient(), passkeyClient()],
});

function assertSuccess(result: { error: { message?: string | undefined } | null }, fallback: string): void {
  if (result.error) throw new Error(result.error.message ?? fallback);
}

export async function signInWithPasskey(): Promise<void> {
  assertSuccess(await authClient.signIn.passkey(), "Passkey sign-in failed.");
}

export async function sendSignInCode(email: string): Promise<void> {
  assertSuccess(await authClient.emailOtp.sendVerificationOtp({ email, type: "sign-in" }), "The sign-in code could not be sent.");
}

export async function verifySignInCode(email: string, code: string): Promise<void> {
  assertSuccess(await authClient.signIn.emailOtp({ email, otp: code, name: email }), "The sign-in code is invalid.");
}

export async function enrollPasskey(): Promise<void> {
  assertSuccess(await authClient.passkey.addPasskey({ name: "Primary passkey" }), "The passkey could not be added.");
}

export async function signOut(): Promise<void> {
  assertSuccess(await authClient.signOut(), "Sign out failed.");
}
